export default "__VITE_ASSET__DRe6a7vK__"